import { styled } from '@mui/material/styles'
import { HappySVG } from '../../../Components/Material/Drawer/Illustrations'
import { Link } from '@mui/material'

const Banner = styled('div')(({ theme }) => ({
  background: '#F5F5F5',
  borderRadius: '8px',
  padding: '16px',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-end',
  gap: '24px',
  marginBottom: '24px',

  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    gap: '8px',
    alignItems: 'center',
  },
}))

const BannerText = styled('div')(({ theme }) => ({
  maxWidth: '650px',

  '> p': {
    margin: 0,
  },
}))

const SVGContainer = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: '150px',
  [theme.breakpoints.up('sm')]: {
    height: '83px',
    transform: 'translateY(-8px)',
  },
}))

export const MessagesBanner = ({
  onClick,
}: {
  onClick: () => void
}): JSX.Element => {
  return (
    <Banner>
      <SVGContainer>
        <HappySVG />
      </SVGContainer>
      <div>
        <BannerText>
          <p>
            Check out your messages and match with any venues you like. They
            will contact you to discuss things further without any commitment to
            book.
          </p>
          <Link
            variant='anchor'
            underline='none'
            onClick={() => onClick()}
            className='how'
            component='button'
          >
            How does this work?
          </Link>
        </BannerText>
      </div>
    </Banner>
  )
}
